$(function () {
	// pjax
	$.pjax({
		area: '#cha-pjax',
		link: '.cha-pjax_button',
		wait: 400
	});
	$(document).bind('pjax:fetch', function(){
		$('#cha-pjax').removeClass('cha-main_desc-fadeIn').addClass('cha-main_desc-fadeOut');
		// var currentHref = window.location.href;
		// // var removeURL = /http:\/\/localhost:3000\/1st\/character\//;
		// // var removeURL = /http:\/\/bang-dream.irokoto.co.jp\/1st\/character\//;
		// // var removeURL = /https:\/\/dev-anime.jiaolvsell.com\/1st\/character\//;
		// var removeURL = /https:\/\/anime.jiaolvsell.com\/1st\/character\//;
		// var currentChara = currentHref.replace(removeURL, '').slice(0, -1);

		var currentHref  = window.location.href;
		var currentArray = currentHref.split('/');
		var currentChara = currentArray[currentArray.length - 2];


		var currentCharaClass = 'cha-main-inner-' + currentChara;
		$('.cha-main-inner').removeClass(currentCharaClass);

		$('.cha-main_list .st-list .st-list_item').each(function(){
			var moveURL = $(this).children('a').prop('href');
			if(currentHref === moveURL){
				$(this).addClass('st-list_item-current');
			} else {
				$(this).removeClass('st-list_item-current');
			}
		});
	});
	$(document).bind('pjax:render', function(){
		$('#cha-pjax').removeClass('cha-main_desc-fadeOut').addClass('cha-main_desc-fadeIn');
		// var currentHref = window.location.href;
		// // var removeURL = /http:\/\/localhost:3000\/1st\/character\//;
		// // var removeURL = /http:\/\/bang-dream.irokoto.co.jp\/1st\/character\//;
		// // var removeURL = /https:\/\/dev-anime.jiaolvsell.com\/1st\/character\//;
		// var removeURL = /https:\/\/anime.jiaolvsell.com\/1st\/character\//;
		// var currentChara = currentHref.replace(removeURL, '').slice(0, -1);

		var currentHref  = window.location.href;
		var currentArray = currentHref.split('/');
		var currentChara = currentArray[currentArray.length - 2];


		var currentCharaClass = 'cha-main-inner-' + currentChara;
		$('.cha-main-inner').addClass(currentCharaClass);

		var shareTwitterHref = 'https://twitter.com/share?url=https://anime.jiaolvsell.com/1st/character/' + currentChara + '/&text=アニメ「BanG Dream!（バンドリ！）」公式サイト&hashtags=バンドリ';
		var shareFacebookHref = 'http://www.facebook.com/share.php?u=https://anime.jiaolvsell.com/1st/character/' + currentChara + '/';
		var shareLineHref = 'https://social-plugins.line.me/lineit/share?url=https://anime.jiaolvsell.com/1st/character/' + currentChara + '/';

		// console.log(shareTwitterHref);
		// console.log(shareFacebookHref);
		// console.log(shareLineHref);

		$('.share-twitter').each(function(){
			$(this).attr('href', shareTwitterHref);
		});
		$('.share-facebook').each(function(){
			$(this).attr('href', shareFacebookHref);
		});
		$('.share-line').each(function(){
			$(this).attr('href', shareLineHref);
		});

		$('.cha-main_list .st-list .st-list_item').each(function(){
			var moveURL = $(this).children('a').prop('href');
			if(currentHref === moveURL){
				$(this).addClass('st-list_item-current');
			} else {
				$(this).removeClass('st-list_item-current');
			}
		});
	});
});



(() => {



	// drawArc
	function drawArc() {
  $('canvas').each(function(){
    var windowWidth = $(window).innerWidth();
    var halfWidth = windowWidth / 2;
    var roundwidth = Math.round(windowWidth);
    var height = windowWidth * 0.039375;
    var roundHeight = Math.round(height);
		var rh = Math.round(height);
    var canvas = document.getElementById('idx-onair_canvas');

    if ( ! canvas || ! canvas.getContext ) { return false; }

    $('canvas').each(function(){
      this.setAttribute('width', windowWidth);
      this.setAttribute('height', roundHeight);
      $(this).css('top', '-' + roundHeight +'px');
    });

    var ctx = canvas.getContext('2d');

		ctx.moveTo(0, roundHeight);
		ctx.lineTo(0, 0);
		ctx.quadraticCurveTo(halfWidth , roundHeight * 2, windowWidth, 0);
		ctx.lineTo(windowWidth, roundHeight);
		ctx.closePath();
		ctx.fillStyle = '#fafafa';
    ctx.fill();
  });
}
	window.addEventListener('load', () => {
		drawArc();
	});
	window.addEventListener('resize', () => {
		drawArc();
	});



	// Menu
	let MenuTarget = document.getElementById('st-header_nav');
	let MenuOpenFlag = false;
	let MenuOpenButton = document.getElementById('st-header-open');
	let MenuCloseButton = document.getElementById('st-header-close');
	MenuOpenButton.addEventListener('click', () => {
		if (!MenuOpenFlag) {
			MenuOpenFlag = true;
			MenuTarget.className = 'st-header_nav st-header_nav-visible';
		}
	})
	MenuCloseButton.addEventListener('click', () => {
		if (MenuOpenFlag) {
			MenuOpenFlag = false;
			MenuTarget.className = 'st-header_nav';
		}
	});



	// topButton
	let topButton = document.getElementById('st-page-top');
	window.onscroll = function() {
		if(window.pageYOffset > 100) {
			topButton.className = 'st-page-top st-page-top-visible';
		} else {
			topButton.className = 'st-page-top st-page-top-hidden';
		}
	}
	$("#st-page-top").on("click", function(){
		$('body,html').animate({
			scrollTop: 0
		}, 800);
		return false;
	});



})();



// WEBPACK FOOTER //
// script.js